import { Line } from "vue-chartjs";
import { ChartConfig } from "@/config/chart.js";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";
import { APP_COLORS } from "@/config/app-colors";

export default {
  extends: Line,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      gradient: null,
      chartOptions: {
        layout: {
          padding: {
            top: 10
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                source: "data",
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor
              },
              type: "time",
              time: {
                minUnit: "day",
                displayFormats: {
                  minute: "DD MMM YY",
                  hour: "DD MMM YY",
                  day: "DD MMM YY",
                  week: "DD MMM YY",
                  month: "DD MMM YY"
                }
              },
              display: true,
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                display: true,
                callback:
                  this.scale.value === "profile_completeness"
                    ? value => value + "%"
                    : value => value,
                stepSize: this.scale.stepSize,
                beginAtZero: false,
                min: this.scale.min,
                suggestedMax: this.scale.suggestedMax,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor
              }
            }
          ]
        }
      },
      chartColor: APP_COLORS.PRIMARY
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  updated() {
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },

  computed: {
    reversedData() {
      return {
        data: [...this.data].reverse()
      };
    }
  },

  methods: {
    render() {
      this.renderChart(
        {
          datasets: [
            {
              label: this.$t("message.common.summary"),
              borderColor: this.chartColor,
              pointBorderColor: this.chartColor,
              pointBackgroundColor: this.chartColor,
              pointHoverBackgroundColor: this.chartColor,
              pointHoverBorderColor: this.chartColor,
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: true,
              backgroundColor: "transparent",
              borderWidth: 3,
              data: this.reversedData.data
            }
          ]
        },
        this.chartOptions
      );
    }
  }
};
